import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { trackEvent } from '../lib/metaPixel';
export function Offer() {
  return <section id="comprar" className="py-24 bg-white" data-id="element-92">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream-50 rounded-3xl p-8 md:p-12 border-2 border-rust-200 text-center shadow-xl" data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-95">
            No necesitas gastar $200 en otra visita al especialista hoy.
          </h2>

          <p className="text-xl text-charcoal-500 mb-10" data-id="element-96">
            Por el precio de una bolsa de premios comerciales, puedes obtener el
            mapa completo para sanar a tu perro desde la raíz.
          </p>

          <div className="bg-white rounded-2xl p-8 mb-10 inline-block border border-cream-200 shadow-sm" data-id="element-97">
            <div className="text-sm font-bold text-rust uppercase tracking-wider mb-2" data-id="element-98">
              Acceso Inmediato
            </div>
            <div className="text-2xl font-serif text-charcoal mb-4" data-id="element-99">
              "SOS Alergias: El Fin del Rascado"
            </div>
            <div className="flex items-center justify-center gap-4" data-id="element-100">
              <span className="text-5xl font-bold text-forest" data-id="element-101">$6.36</span>
              <span className="text-xl text-charcoal-400 font-medium mt-2" data-id="element-102">
                USD
              </span>
            </div>
          </div>

          <div data-id="element-103">
            <Button href="https://pay.hotmart.com/R105749041E?bid=1778387236142" showTrust onLinkClick={() => trackEvent('AddToCart', {
            content_name: 'SOS Alergias: El Fin del Rascado',
            content_ids: ['R105749041E'],
            content_type: 'product',
            value: 6.36,
            currency: 'USD'
          })} className="w-full sm:w-auto px-12 py-5 text-xl" data-id="element-104">
              ¡SÍ, QUIERO QUE MI PERRO DEJE DE SUFRIR!
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}